import { ApiHosts, handleResponseOld, makeGet } from '@/redux/api/helpers';
import { getBidLimitBalanceParams, getBidLimitBalanceResponse } from './bidLimit.types';

/**
 * @category Approval API
 * @see getBidLimitBalance
 */

/**
 * GET request to approval API service that returns bid limits for given bidder and catalog
 * @function getBidLimitBalance
 * @category Approval API
 * @param {getBidLimitBalanceParams}
 * @returns {getBidLimitBalanceResponse}
 * @see https://approval-DEPLOYMENT.liveauctioneers.com/approval/catalog/${catalogId}/bidder/${bidderId}/bidLimit
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/ou2a17vn9h/resources/s5oicr/methods/GET
 * @see https://github.com/LIVEauctioneers/approval/tree/master/functions/GetBidLimitRemaining
 */
export const getBidLimitBalance = ({ authToken, bidderId, catalogId, deployment, itemId }: getBidLimitBalanceParams) =>
    new Promise<getBidLimitBalanceResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: `catalog/${catalogId}/bidder/${bidderId}/bidLimit`,
            authToken,
            deployment,
            path: ApiHosts.Approval,
        });
        if (Boolean(itemId)) {
            request.query({ lotId: itemId });
        }
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
